
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Popup from 'vux/src/components/popup/index.vue'

export default {
components:{ XButton, Flexbox, FlexboxItem, Popup  },
data(){
return{
setDays: 90,
typeSelection: null,
timeSelection: null,
setFlexboxValue:false,
selectionTime: ['24小时','7日','1个月'],
selectionType:[
{name: '全部',code: 0},{name: '系统调帐',code: 1},{name: '充值存款',code: 2},
{name: '秒速提款',code: 3},{name: '转入游戏',code: 4},{name: '游戏转出',code: 5},
{name: '优惠红利',code: 8},{name: '人工存入',code: 9},{name: '人工取出',code: 10},
]
}
},
methods:{
timeExchange(val) {
switch (val) {
case 0:
return 1
case 1:
return 7
case 2:
return 30
default:
return;
}
},
chooseTerrace(str,val) {
this[str] = val
},
handCloseSearch() {
this.setFlexboxValue = false;
let obj = {
setFlexboxValue: this.setFlexboxValue,
setDays: this.setDays,
}
this.$emit('handCloseSearch',obj)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/components/dialog.vue